import React from 'react';
import DailyComplianceTasks from './DailyComplianceTasks';

const TaskReport = () => {
  return <DailyComplianceTasks mode="report" />;
};

export default TaskReport;
